unit SpecialismType;

interface

type
  TSpecialismType = class
  private
    fSpecialismKey: String;
    fName: String;
    fActive: Boolean;
  public
    property SpecialismKey: String read fSpecialismKey;
    property Name: String read fName;
    property Active: Boolean read fActive;
  end;

implementation

end.
